import { DSNotifications } from '../../../cimsPage/instances/ds'
import { Notifications } from '../../common'

const { Edit, View } = Notifications({
  page: DSNotifications,
  view: '1de20e85-cdd8-4b30-9e1a-6bf3054732f0',
  edit: 'ca170988-5130-4c57-9c4d-38eabd44946e',
})

export const ViewDSNotification = View
export const EditDSNotification = Edit

export type DSNotificationPermission =
  | typeof ViewDSNotification
  | typeof EditDSNotification
